<div class="logos-wrapper">
  <emperor-button
    *ngFor="let carrier of carriers"
    [uiButtonType]="EmperorUIButtonTypes.Stroked"
    class="carrier-image emperor-ui-manually-set-size"
    [disabled]="(hasPermissionToView$ | async) === false"
    [emperorTooltip]="carrier.carrier_name"
    (click)="openAppointmentDialog(carrier)"
    [attr.data-testid]="carrier.carrier_subdomain + '-button'"
  >
    <div class="img-container">
      <img
        class="logo"
        [src]="carrier.logo_path"
        [alt]="carrier.carrier_name"
      />
    </div>
  </emperor-button>
</div>
